//
// Легенда для карты 
//
var Legend = (function () {
    var state = 'noInit';
    var legendType = '';

    var minValRain = 'слабые';
    var maxValRain = 'сильные';

    var legend = $('#weater-forecast-settings-legend');
    var legendScale = $('#legend-scale');
    var image = $('#legend-image');
    var table = $('#legend-table');
    
    //отступ от края до графической шкалы
    var delta = +legend.css('border-left').split(" ")[0].replace('px', '') + (+legend.css('padding-left').replace('px', ''));
              //delta = 13 с каждого края в сумме 26 нужно отнять от общей ширины картинки
              //альтернативный вариант расчета отсутпа, реальная ширина картинки Wt = $('#legend-image').width();
    //отступ с лева это margin = (inWidth() - Wt) / 2

    var colorCell = ["#FB29FB", "#D029FB", "#A01FF7", "#1F4AF7", "#297DFB",
                     "#297DFB", "#29A7FB", "#33D5FE", "#29FBFB", "#84FD33",
                     "#A7FB29", "#D0FB29", "#FDFD33", "#FBD029", "#FBA729",
                     "#FB7D29", "#FB5429", "#FB2929", "#FB2954", "#FB297D",
                     "#FB29A7", "#FB29D1", "#FB29FB"];

    // Инициализируем легенду 
    //
    // widhtControl - ширина контрола на форме в "px"
    // step - шаг
    // imageUri - местонахождение картинки
    // type - тип погодных условий (название слоя) - temp, rain
    //        для rain характерно два крайних значения в подписи, которые задаются строковыми параметрами minValRain и maxValRain
    function init(widhtControl, imageUri, type) {
        if (state === 'init') {
            if (type === legendType) {
                Legend.show();
                return;
            } else {
                this.close();
            };
        };

        legendType = type;

        legend.width(widhtControl);

        var intWidhtControl = +widhtControl.replace('px', '');
        var widthConvas = (+intWidhtControl + (2 * delta));
        var realWidht = widthConvas;

        // выводим подписи в зависимости от слоя
        switch (legendType) {
            case "temp":
                var th = '';
                colorCell.forEach(function (val, i) {
                    th +='<th style="background-color:' + val + '">&nbsp</th>';
                });
                $('#legend-color-table tr').html(th);

                var indentVal = 10;
                if (colorCell.length > 0) {
                    indentVal = (intWidhtControl / colorCell.length) / 2;
                };
                $('#legend-text').css('padding-left', indentVal + 'px')
                                 .css('margin-right', '-' + indentVal + 'px');

                legendScale.html('');

                image.hide();
                table.show();
                break;
            case "rain":
                image.css('background-image', imageUri);
                image.prepend('<canvas class="legend-image-canvas" width="' + widthConvas + 'px" id="legend-image-canvas"></canvas>');

                var canvas = document.getElementById("legend-image-canvas");
                var context = canvas.getContext("2d");

                writeCaptionRain(intWidhtControl);
                image.show();
                table.hide();
                break;
        }

        $('#legend-image-canvas').css('width', intWidhtControl + (2 * delta));

        state = 'init';
        Legend.show();
    };

    function close() {
        hide();
        $('#legend-image-canvas').remove();
        state = 'noInit';
    };
    
    // Отображаем легенду карты
    function show() {
        if (state === 'noInit') {
            console.log('Legend not initialise');
            return;
        };

        legend.show();
    };

    // Скрываем легенду карты
    function hide() {
        legend.hide();
    };

    //Выводим подписи к шкале 
    function writeCaptionRain(intWidhtControl) {
        legendScale.html('');
        var left = (intWidhtControl / 2) + delta;
        legendScale.append('<div class="legend-caption" style="width:' + intWidhtControl / 2 + 'px; text-align:left;">' + minValRain + '</div>');
        legendScale.append('<div class="legend-caption" style="width:' + intWidhtControl / 2 + 'px; text-align:right; left:' + left + 'px;">' + maxValRain + '</div>');
    };

    //----------------------------------------

    return {
      show: show,
      hide: hide,
      state: state,
      init: init,
      close: close,
      minValRain: minValRain,
      maxValRain: maxValRain,
      legendType: legendType,
      delta: delta,
      legend: legend
    };
}());
